export const px2cm = (px, dpi) => {
  return (px * 2.54) / dpi;
};
